// Based on https://overreacted.io/making-setinterval-declarative-with-react-hooks/
// if delay === false, polling is paused
// Before you use it, please follow discussions in https://github.com/rtkwlf/awn/pull/23865
// or talk to Tom to get an understanding of the side effects.
import * as React from 'react';

export const useInterval = (callback: () => void, delay: number | false) => {
  const savedCallback = React.useRef<() => void>();

  React.useEffect(() => {
    savedCallback.current = callback;
  });

  React.useEffect(() => {
    const tick = () => {
      savedCallback.current!();
    };

    if (delay !== false) {
      const id = setInterval(tick, delay);
      return () => clearInterval(id);
    }
  }, [delay]);
};
